<template>
  <v-container fluid class="package-content-list pa-0">
    <v-container fluid class="package-content-list-content">
      <v-expansion-panels>
        <v-expansion-panel v-for="(item, idx) in contents"
                           :key="idx">
          <v-expansion-panel-header>
            <template #default="{open}">
              <v-container fluid class="pa-0">
                <v-row no-gutters>
                  <v-col>
                    {{ $t(PACKAGE_CONTENT_TYPE_LABEL[item.type]) }}
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="!open">
                  <v-col>
                    <small class="form-text text-muted">{{ getContentDescription(item) }}</small>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <v-row>
              <v-col>
                <v-select :label="$t('admin_acc_package_type.content_type')"
                          :items="contentTypeOptions"
                          v-model="item.type"
                          :rules="requiredRules"></v-select>
              </v-col>
            </v-row>
            <v-row v-if="item.type === PACKAGE_CONTENT_TYPE.POINT">
              <v-col>
                <v-text-field :label="$t('admin_acc_package_type.point')"
                              v-model="item.point"
                              :rules="numberRules"
                              type="number"
                              min="0"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="item.type === PACKAGE_CONTENT_TYPE.COUPON">
              <v-col>
                <v-select :label="$t('admin_acc_package_type.coupon_item_type')"
                          :items="itemTypeOptions"
                          v-model="item.coupon.item_type_id"></v-select>
              </v-col>
            </v-row>
            <v-row v-if="item.type === PACKAGE_CONTENT_TYPE.COUPON && item.coupon.item_type_id">
              <v-col>
                <v-text-field :label="$t('admin_acc_package_type.coupon_count')"
                              v-model="item.coupon.count"
                              :rules="numberRules"
                              type="number"
                              min="0"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="item.type === PACKAGE_CONTENT_TYPE.COUPON && item.coupon.item_type_id">
              <v-col>
                <v-text-field :label="$t('admin_acc_package_type.coupon_amount')"
                              v-model="item.coupon.amount"
                              :rules="numberRules"
                              prefix="HKD"
                              type="number"
                              min="0"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="item.type === PACKAGE_CONTENT_TYPE.COUPON && item.coupon.item_type_id">
              <v-col>
                <v-input :rules="couponValidUntilRules"
                         v-model="item.coupon.valid_until">
                  <v-container fluid class="flex-column pa-0">
                    <legend class="v-label theme--light">{{ $t('admin_acc_package_type.coupon_valid_until') }}</legend>
                    <DateTimePickerInput v-model="item.coupon.valid_until"
                                         hide-details></DateTimePickerInput>
                  </v-container>
                </v-input>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col class="text-right">
                <v-tooltip top>
                  <template #activator="{on, attrs}">
                    <v-btn icon
                           v-on="on"
                           v-bind="attrs"
                           @click="removeContentItem(idx)">
                      <v-icon>fas fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('admin_acc_package_type.remove_content') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row class="flex-grow-0 mt-4">
        <v-col>
          <v-btn block
                 @click="addContentItem">
            <v-icon class="mr-4">fas fa-plus</v-icon>
            {{ $t('admin_acc_package_type.add_content') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <!--    <v-divider></v-divider>-->
    <!--    <v-row class="package-content-list-footer" no-gutters>-->
    <!--      <v-spacer></v-spacer>-->
    <!--      <v-tooltip top>-->
    <!--        <template #activator="{on, attrs}">-->
    <!--          <v-btn icon-->
    <!--                 v-on="on"-->
    <!--                 v-bind="attrs"-->
    <!--                 @click="addContentItem">-->
    <!--            <v-icon>fas fa-plus</v-icon>-->
    <!--          </v-btn>-->
    <!--        </template>-->
    <!--        <span>{{ $t('admin_acc_package_type.add_content') }}</span>-->
    <!--      </v-tooltip>-->
    <!--    </v-row>-->

  </v-container>
</template>

<script>
import {ref, computed, watch, onMounted} from "@vue/composition-api";
import _ from "lodash";
import {DateTime} from 'luxon';
import {PACKAGE_CONTENT_TYPE, PACKAGE_CONTENT_TYPE_LABEL} from "@/constants";
import DateTimePickerInput from "@/components/DateTimePickerInput";

export default {
  name: 'PackageContentList',
  components: {DateTimePickerInput},
  props: {
    value: Array,
  },
  setup(props, {root, emit}) {
    onMounted(() => {
      getItemTypes();
    })

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const contentTypeOptions = ref(Object.values(PACKAGE_CONTENT_TYPE).map(
        (type) => {
          return {
            text: root.$t(PACKAGE_CONTENT_TYPE_LABEL[type]),
            value: type,
          }
        })
    );

    const contents = ref([]);
    const getContentDescription = function (item) {
      if (item.type === PACKAGE_CONTENT_TYPE.POINT) {
        return `${item.point} ${root.$t('package_content_type.point')}`;
      }
      if (item.type === PACKAGE_CONTENT_TYPE.COUPON && item.coupon.item_type_id) {
        return `${item.coupon.count} X ${itemTypeNameMap.value[item.coupon.item_type_id]} @ $${item.coupon.amount}`
      }
    };
    const addContentItem = function () {
      contents.value.push({
        type: null,

        point: 0,

        coupon: {
          count: 0,
          item_type_id: null,
          amount: 0,
          valid_until: null,
        },
      })
    };
    const removeContentItem = function (idx) {
      contents.value.splice(idx, 1);
    }

    // Point
    const numberRules = ref([
      value => !!value || root.$t('register.required_fields'),
      value => value > 0 || root.$t('error_messages.invalid_number_input'),
    ])

    // Coupon
    const itemTypes = ref([]);
    const itemTypeNameMap = computed(() => {
      let map = {};

      itemTypes.value.forEach((t) => {
        map[t.id] = t.name;
      })

      return map;
    })
    const itemTypeOptions = computed(() => {
      return itemTypes.value.map((t) => {
        return {text: t.name, value: t.id};
      })
    });
    const getItemTypes = function () {
      root.$callAPI('aafb/admin/item_type/', {}, function (response) {
        itemTypes.value = response.body.item_types;
      });
    }
    const couponValidUntilRules = ref([
      value => !!value || root.$t('register.required_fields'),
      value => DateTime.fromISO(value) > DateTime.fromJSDate(new Date()) || root.$t('admin_acc_package.invalid_coupon_valid_until'),
    ])

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        contents.value = newValue;
      }
    }, {deep: true, immediate: true});

    watch(() => contents.value, (newValue) => {
      emit('input', newValue);
    })

    return {
      requiredRules,
      contentTypeOptions,
      contents,
      getContentDescription,
      addContentItem,
      removeContentItem,

      numberRules,

      itemTypeOptions,
      couponValidUntilRules,

      PACKAGE_CONTENT_TYPE,
      PACKAGE_CONTENT_TYPE_LABEL,
    }
  },
}
</script>

<style lang="less">
.package-content-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .package-content-list-content {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .package-content-list-item {
      flex: 0 0 auto;
    }
  }

  .package-content-list-footer {
    flex: 0 0 auto;
  }
}
</style>
